import { tv } from "../../../variants/tv.js";
const checkboxSizes = {
    16: {
        root: 'h-4 w-4',
        indicator: 'h-4 w-4',
        labelSlot: 'text-body3'
    },
    20: {
        root: 'h-5 w-5',
        indicator: 'h-5 w-5',
        labelSlot: 'text-body2'
    },
    24: {
        root: 'h-6 w-6',
        indicator: 'h-6 w-6',
        labelSlot: 'text-body1'
    }
};
const allowedCheckboxSizes = Object.keys(checkboxSizes);
const checkboxEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13 has-data-disabled:text-primary-6',
        root: `
    text-primary-1 bg-primary-1 border border-primary-6
    hover:border-primary-10 group-hover/control:border-primary-10 focus-visible:outline-primary-8

    data-checked:bg-primary-8 data-checked:border-none
    hover:data-checked:bg-primary-9 group-hover/control:data-checked:bg-primary-9

    data-indeterminate:bg-primary-8 data-indeterminate:border-none
    hover:data-indeterminate:bg-primary-9 group-hover/control:data-indeterminate:bg-primary-9

    data-disabled:bg-primary-2 data-disabled:text-primary-6 data-disabled:border-primary-5 data-disabled:hover:border-primary-5 data-disabled:group-hover/control:border-primary-5
    data-disabled:data-checked:bg-primary-2 data-disabled:data-checked:border-none
    data-disabled:hover:data-checked:bg-primary-2 data-disabled:group-hover/control:data-checked:bg-primary-2
    data-disabled:data-indeterminate:bg-primary-2 data-disabled:data-indeterminate:border-none
    data-disabled:hover:data-indeterminate:bg-primary-2 data-disabled:group-hover/control:data-indeterminate:bg-primary-2
    `
    },
    medium: {
        labelSlot: 'text-primary-13 has-data-disabled:text-primary-6',
        root: `
    text-primary-1 bg-primary-1/60 border border-primary-6
    hover:border-primary-10 group-hover/control:border-primary-10 focus-visible:outline-primary-8

    data-checked:bg-primary-8 data-checked:border-none
    hover:data-checked:bg-primary-9 group-hover/control:data-checked:bg-primary-9

    data-indeterminate:bg-primary-8 data-indeterminate:border-none
    hover:data-indeterminate:bg-primary-9 group-hover/control:data-indeterminate:bg-primary-9

    data-disabled:bg-primary-1/60 data-disabled:text-primary-6 data-disabled:border-primary-5 data-disabled:hover:border-primary-5 data-disabled:group-hover/control:border-primary-5
    data-disabled:data-checked:bg-primary-1/60 data-disabled:data-checked:border-none
    data-disabled:hover:data-checked:bg-primary-1/60 data-disabled:group-hover/control:data-checked:bg-primary-1/60
    data-disabled:data-indeterminate:bg-primary-1/60 data-disabled:data-indeterminate:border-none
    data-disabled:hover:data-indeterminate:bg-primary-1/60 data-disabled:group-hover/control:data-indeterminate:bg-primary-1/60
    `
    },
    bold: {
        labelSlot: 'text-primary-1 has-data-disabled:text-primary-1/40',
        root: `
    text-primary-8 bg-primary-1/20 border border-primary-1/40
    hover:border-primary-1 group-hover/control:border-primary-1 focus-visible:outline-primary-1

    data-checked:bg-primary-1 data-checked:border-none
    hover:data-checked:bg-primary-1/80 group-hover/control:data-checked:bg-primary-1/80

    data-indeterminate:bg-primary-1 data-indeterminate:border-none
    hover:data-indeterminate:bg-primary-1/80 group-hover/control:data-indeterminate:bg-primary-1/80

    data-disabled:bg-primary-1/20 data-disabled:text-primary-1/40 data-disabled:border-primary-1/20 data-disabled:hover:border-primary-1/20 data-disabled:group-hover/control:border-primary-1/20
    data-disabled:data-checked:bg-primary-1/20 data-disabled:data-checked:border-none
    data-disabled:hover:data-checked:bg-primary-1/20 data-disabled:group-hover/control:data-checked:bg-primary-1/20
    data-disabled:data-indeterminate:bg-primary-1/20 data-disabled:data-indeterminate:border-none
    data-disabled:hover:data-indeterminate:bg-primary-1/20 data-disabled:group-hover/control:data-indeterminate:bg-primary-1/20
    `
    }
};
const checkboxEmphases = Object.keys(checkboxEmphasisVariants);
const checkboxVariants = tv({
    slots: {
        labelSlot: 'group/control flex cursor-pointer flex-row gap-2 has-data-disabled:cursor-not-allowed',
        root: 'group relative inline-flex flex-none cursor-pointer items-center justify-center rounded-sm align-middle transition group-hover/control:shadow-input-hover hover:shadow-input-hover focus-visible:outline-2 focus-visible:outline-offset-2 data-checked:transition data-disabled:cursor-not-allowed data-disabled:group-hover/control:shadow-none data-disabled:hover:shadow-none data-indeterminate:transition',
        indicator: 'inline-flex items-center justify-center overflow-hidden align-middle transition data-checked:transition data-indeterminate:transition',
        icon: 'transition data-checked:transition data-indeterminate:transition'
    },
    variants: {
        size: checkboxSizes,
        emphasis: checkboxEmphasisVariants,
        isCheckboxGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isCheckboxGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        layout: 'vertical'
    }
});
export { allowedCheckboxSizes, checkboxEmphases, checkboxEmphasisVariants, checkboxSizes, checkboxVariants };
